import { Component, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UserTermsConditionsComponent } from '../../../../../account/user-settings/user-terms-conditions/user-terms-conditions.component';
import { UserTermsUseComponent } from '../../../../../account/user-settings/user-terms-use/user-terms-use.component';

import * as computedToInline from 'computed-style-to-inline-style';
import printJS from 'print-js';
//declare var printJS: any;

@Component({
  selector: 'upsc-paperless-commercial-invoice-terms-dialog',
  templateUrl: './paperless-commercial-invoice-terms-dialog.component.html',
  styleUrls: ['./paperless-commercial-invoice-terms-dialog.component.scss'],
})
export class PaperlessCommercialInvoiceTermsDialogComponent implements OnInit, OnDestroy {
  @HostBinding('class') public hostClass = 'paperless-commercial-invoice-terms-dialog';

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<PaperlessCommercialInvoiceTermsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public ngOnInit() {
  }

  public ngOnDestroy() {
  }

  public printTerms(event) {
    event.preventDefault();

    // computedToInline(document.getElementById('invoice-terms'), { recursive: true });
    printJS({ printable: 'invoice-terms', type: 'html', showModal: true, targetStyles: ['*'] });
  }

  public closeDialog(event, result) {
    event.preventDefault();

    this.dialogRef.close(result);
  }

  public openTermsAndConditionsDialog(event) {
    event.preventDefault();

    const dialogConfig: MatDialogConfig = {
      disableClose: true,
      width: '70%',
      data: {},
    };

    let dialogRef: MatDialogRef<UserTermsConditionsComponent>;
    dialogRef = this.dialog.open(UserTermsConditionsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  public openTermsOfUseDialog(event) {
    event.preventDefault();

    const dialogConfig: MatDialogConfig = {
      disableClose: true,
      width: '70%',
      data: {},
    };

    let dialogRef: MatDialogRef<UserTermsUseComponent>;
    dialogRef = this.dialog.open(UserTermsUseComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }
}
